export default {
  fontFamily: "en-font-family",
  classLang: "en",
  headlist: [
    // {
    //   text: "Home",
    //   url: "/",
    // },
    {
      text: "Trading",
      menu: [
        {
          tit: "Trading Products",
          list: [
            {
              text: "Forex",
              url: "/tradingproduct?index=0",
            },
            {
              text: "Commodities",
              url: "/tradingproduct?index=1",
            },
            {
              text: "Indices",
              url: "/tradingproduct?index=2",
            },
            {
              text: "Stocks",
              url: "/tradingproduct?index=3",
            },
            {
              text: "ETFs",
              url: "/tradingproduct?index=4",
            },
          ],
        },
        {
          tit: "Account & Conditions",
          list: [
            {
              text: "Trading Accounts",
              url: "/TradingAccount",
            },
            // {
            //   text: "Trading Products",
            //   url: "/tradingproduct",
            // },
            {
              text: "Leverage & Margin",
              url: "/leverage-margin",
            },
            {
              text: "Deposit & Withdrawals",
              url: "/funding",
            },
            {
              text: "Dividend",
              url: "/dividend",
            },{
              text: "Institutional Services",
              url: "/service",
            },
            {
              text: "Liquidity Solutions",
              url: "/technology",
            },
          ],
        },
        {
          tit: "Trading Tools",
          list: [
            {
              text: "MT4 Download",
              url: "/MT4",
            },
            {
              text: "MT5 Download",
              url: "/MT5",
            },
            {
              text: "EA Trading and Indicators",
              url: "/tools",
            },
            {
              text: "PAMM",
              url: "/PAMM",
            },
            {
              text: "Market Analysis",
              url: "/market-analysis",
            },
          ],
        },
      ],
    },
    {
      text: "EBC Institute",
      menu: [
        {
          list: [
            {
              text: "Learning Center",
              url: "/LearningCenter",
            },
            {
              text: "Data Center",
              url: "/lab",
            },
          ],
        },
      ],
    },
    
    {
      text: "About EBC",
      tips: "",
      img: "55",
      menu: [
        {
          tit: "About EBC",
          list: [
            {
              text: "Why EBC",
              url: "/about-us",
            },
            {
              text: "Sustainability & Impact",
              url: "/ESG",
            },
            
            {
              text: "EBC News",
              url: "/LearningCenter?tabId=1",
            },
            {
              text: "FAQ",
              url: "https://support.ebchelp.com/hc/en-001",
            },
            {
              text: "Official Channel Verification",
              url: "/official-verification",
            },
          ],
        },
        {
          tit: "Partners",
          list: [
            {
              text: "FC Barcelona",
              url: "/FCB",
            },
            {
              text: "Đại học Oxford",
              url: "/partners/oxford",
            },
            {
              text: "Affiliate Programmes",
              url: "/affiliate-programmes",
            },
            // {
            //   text: "Institutional Services",
            //   url: "/service",
            // },
            // {
            //   text: "Liquidity Solutions",
            //   url: "/technology",
            // },
          ],
        },
      ],
    },
    {
      text: "Activities",
      url: "",
      menu: [
        {
          tit: "EBC Activities",
          list: [
            {
              text: "EBC‘s Million Dollar Trading Challenge",
              url: "/million-dollar-challenge-2",
            },
            
            {
              text: "Enjoy Monthly Payouts",
              url: "/pay",
            },{
              text: "More Activities",
              url: "/activity",
            },
           
          ],
        },
      ],
    },
    {
      text: "Copy Trading",
      url: "https://ebcfinsns.co/",
    },
  ],
  FCA开户: "FCA Account",
  立即开户: "Register",
  登录: "Login",
  官方验证: "Official Channel Verification",
  帮助中心: "FAQ",
  帮助中心Url: "https://support.ebchelp.com/hc/en-001",
};
